import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'

import { api, problemDetail } from '@/services/api'
import type { Highlight } from '@/types/api'

export function StudyNote({ highlight }: { highlight: Highlight }) {
  const [editing, setEditing] = useState(false)
  const [text, setText] = useState(highlight.note ?? '')
  const cache = useQueryClient()
  const save = useMutation({
    mutationFn: async () => (await api.patch<Highlight>(`/reader/highlights/${highlight.id}`, { note: text })).data,
    onSuccess: (updated) => {
      cache.setQueryData<Highlight[]>(['highlights', highlight.book_id], (rows) => rows?.map((h) => h.id === updated.id ? updated : h))
      setEditing(false)
    },
  })
  return <div className="study-note">
    {highlight.note && <p><strong>Minha anotação:</strong> {highlight.note}</p>}
    {!editing ? <button type="button" disabled={highlight.id.startsWith('tmp-')}
      onClick={() => { setText(highlight.note ?? ''); setEditing(true) }}>
      {highlight.note ? 'Editar anotação' : 'Adicionar anotação'}
    </button> : <form onSubmit={(event) => { event.preventDefault(); save.mutate() }}>
      <label htmlFor={`note-${highlight.id}`}>Minha anotação de estudo</label>
      <textarea id={`note-${highlight.id}`} rows={4} maxLength={5000} value={text}
        onChange={(event) => setText(event.target.value)} disabled={save.isPending} />
      <button type="submit" disabled={save.isPending}>{save.isPending ? 'Salvando…' : 'Salvar anotação'}</button>
      <button type="button" disabled={save.isPending} onClick={() => setEditing(false)}>Cancelar</button>
      <p>Para remover apenas a anotação, apague o texto e salve.</p>
    </form>}
    {save.isError && <p role="alert">{problemDetail(save.error) ?? 'Não foi possível salvar sua anotação.'}</p>}
  </div>
}
